import React, {useState} from 'react'
import Select from "react-dropdown-select";
import ftmlogo from '../../assets/images/fresh-thyme-market-logo.png';
import {useEffect} from "react";
import {SummaryModal} from "../modals/SummaryModal";
import {authService} from "../../service/auth/auth.service";
import {getHandleBlur} from "../../utils/dateValidator";
import DynamicAlert from "../../helpers/dynamicAlert";
import Auth0DetailsForm from "./Auth0DetailForm";
import "./Update.css";
import CustomerComparisonTable from "./CustomerComparisonTable";
import {useAuth0} from "@auth0/auth0-react";
import Employment from "../../pages/admin/Employment";
import AdminActions from "../../pages/admin/AdminActions";
import UpdatePI from "../../pages/admin/UpdatePI";

export const AdminUpdate = (props) => {
    const {
        handleSubmit,
        handleChange,
        error,
        stores,
        changeStoreLocation,
        showSummary,
        registering,
        alert,
        lookingUp,
        setLookupData,
        lookupError,
        handleLookup,
        lookUpResponse,
        user,
        handleSummaryClose,
        autoSet,
        showAlert,
        setLookUpResponse,
        userName,
        employeeStatusList,
        auth0Details,
        userImage,
        cosmosCustomer, comparisonSummary
    } = props;

    const [activeTab, setActiveTab] = useState('table');
    const {logout} = useAuth0();
    const [openDropdown, setOpenDropdown] = useState(false);
    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };
    const showDetails = {comparisonDetails: lookUpResponse?.meta?.comparisonSummary, showSummary, handleSummaryClose};
    const [defaultStore, setDefaultStore] = useState();
    const storeNumber = cosmosCustomer?.storeNumber;
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [lookupFields] = useState([{
        "id": "email", "label": "Email"
    }, {
        "id": "loyaltyId", "label": "LoyaltyId"
    }, {
        "id": "phoneNo", "label": "Phone"
    }]);
    useEffect(() => {
        if (storeNumber && stores.length > 0) {
            const foundStore = stores.find(
                store => store.storeNumber?.toString() === storeNumber?.toString()
            );

            setDefaultStore(foundStore);

            if (!autoSet && foundStore) {
                changeStoreLocation(
                    {
                        target: {name: "storeLocation", value: foundStore?.originalEcomName}
                    },
                    foundStore?.storeNumber
                );
            }
        } else {
            setDefaultStore();
        }
    }, [storeNumber, stores, autoSet, changeStoreLocation]);


    function handleStoreChange(values) {
        if (values && values?.length > 0) {
            changeStoreLocation({
                target: {
                    name: "storeLocation", value: values[0].originalEcomName
                }
            });
            changeStoreLocation({
                target: {
                    name: "storeNumber", value: values[0].storeNumber
                }
            });
        }
    }

    function handleFieldChange(values) {
        setLookupData((oldLookupData) => {
            oldLookupData.fieldType = values[0].id;
            return oldLookupData;
        });

    }

    function handleSearchValueChange(e) {
        e.persist();
        setLookupData((oldLookupData) => {
            oldLookupData.searchValue = e.target.value;
            return oldLookupData;
        });
    }

    const handleUpdateWynshopLoyaltyId = (customerId) => {
        authService.updateWynshopLoyaltyId(customerId).then(data => {
            if (data && !data?.error) {
                lookUpResponse.meta.wynshopCustomer.loyaltyId = lookUpResponse?.meta?.wynshopCustomer?.loyaltyId.substring(0, 11);
                showAlert('Updated loyaltyId successful!', "success");
            } else {
                showAlert(data?.error, "danger")
            }
        }, error => {
            showAlert(error, "danger");
        });
    }

    const handleDeleteAccount = (e) => {
        e.preventDefault();
        const userConfirmed = window.confirm("Are you sure you want to proceed?");
        if (userConfirmed) {
            authService.deleteCustomerRecord(user?.email).then(data => {
                if (data && data?.message && data?.statusCode !== "500") {
                    showAlert(`Deleted ${user?.email} successfully!`, "success");
                    setLookUpResponse({});
                } else {
                    showAlert(data?.message, "danger")
                }
            }, error => {
                showAlert(error, "danger");
            });
        }
    }

    const handleResetPasswordLink = (e) => {
        e.preventDefault();
        const userConfirmed = window.confirm("Do you want to send password link?");
        if (userConfirmed) {
            authService.resetPassword(user?.customerId).then(data => {
                if (data && data.success) {
                    showAlert(`Email sent to ${user?.email} successfully!`, "success");
                    setLookUpResponse({});
                } else {
                    showAlert(data?.error, "danger")
                }
            }, error => {
                showAlert(error, "danger");
            });
        }
    }

    const handleVerifyEmailLink = (e) => {
        e.preventDefault();
        const userConfirmed = window.confirm("Do you want to send verify email link?");
        if (userConfirmed) {
            authService.sendEmailVerifyLink(user?.customerId).then(data => {
                if (data && !data?.error) {
                    showAlert(`Email sent to ${user?.email} successfully!`, "success");
                    setLookUpResponse({});
                } else {
                    showAlert(data?.error, "danger")
                }
            }, error => {
                showAlert(error, "danger");
            });
        }
    }

    const handleBlur = (event) => {
        if (event.target.value.length < 11) {
            const value = getHandleBlur(event);
            if (value) {
                handleChange({target: {name: 'birthday', value: value}})
            }
        }
    }

    const handleLogoutAccount = () => {
        setIsLoggingOut(true);

        try {
            logout({
                logoutParams: {
                    returnTo: `${window.location.origin}/admin/update/profile`,
                },
            });
        } catch (err) {
            console.error(err);
            setIsLoggingOut(false);
        }
    };


    const warnings = [];
    if (employeeStatusList[0]?.loyaltyIdVerification === false) warnings.push("LoyaltyId does not match.");
    if (employeeStatusList[0]?.emailVerification === false) warnings.push("Email not matched, Please verify in workday.");
    if (employeeStatusList[0]?.phoneVerification === false) warnings.push("Phone not matched, Please verify in workday.");

    const commonControlStyle = {
        height: "45px",
        width: "150px",
        borderRadius: "8px",
        border: "2px solid #dcdcdc",
        fontSize: "15px"
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                paddingTop: "40px",
                boxSizing: "border-box",
            }}
        >
            <div
                style={{
                    maxWidth: "1100px",
                    margin: "0",
                    padding: "40px",
                    borderRadius: "16px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
                }}>
                <div style={{textAlign: "center"}}>
                    <img src={ftmlogo}
                         alt="Fresh Thyme Market logo"
                         width="180"/>
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "2px"
                    }}>
                    {userName && (
                        <div style={{position: "relative"}}>
                            <button onClick={() => setOpenDropdown(!openDropdown)}
                                    className="btn btn-light"
                                    style={{
                                        border: "1px solid #ddd",
                                        borderRadius: "10px",
                                        padding: "8px 14px",
                                        maxWidth: "250px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        background: "#fff"
                                    }}>
                                <span style={{
                                    fontWeight: "600",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "120px"
                                }}>{userName}</span>
                                <img src={userImage}
                                     alt="user"
                                     style={{
                                         width: "35px",
                                         height: "35px",
                                         borderRadius: "50%",
                                         objectFit: "cover",
                                         flexShrink: 0
                                     }}/>

                                <span style={{
                                    fontSize: "12px",
                                    transform: openDropdown
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                    transition: "0.2s"
                                }}>▼</span>
                            </button>

                            {openDropdown && (
                                <div style={{
                                    position: "absolute",
                                    top: "110%",
                                    right: 0,
                                    background: "#fff",
                                    border: "1px solid #ddd",
                                    borderRadius: "10px",
                                    minWidth: "160px",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                    zIndex: 1000,
                                    overflow: "hidden"
                                }}>
                                    <button onClick={handleLogoutAccount}
                                            disabled={isLoggingOut}
                                            style={{
                                                width: "100%",
                                                padding: "12px 15px",
                                                border: "none",
                                                background: "white",
                                                textAlign: "left",
                                                cursor: "pointer"
                                            }}>
                                        Logout
                                        {isLoggingOut && (
                                            <i className="fa fa-spinner fa-spin ms-2"/>
                                        )}
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <form>
                    <DynamicAlert alert={alert}/>

                    <div className="text-center m-6-auto section-title">
                        <h4>Find Account Information</h4>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "15px",
                            width: "100%"
                        }}
                    >
                        <div
                            style={{
                                width: "150px",
                                minWidth: "150px",
                                maxWidth: "150px",
                                position: "relative"
                            }}
                        >
                            <Select
                                onChange={handleFieldChange}
                                options={lookupFields}
                                dropdownHeight="350px"
                                labelField="label"
                                valueField="id"
                                name="fieldType"
                                placeholder="Select field"
                                style={{
                                    ...commonControlStyle,
                                    width: "150px",
                                    minWidth: "150px",
                                    maxWidth: "150px",
                                    paddingRight: "0px",
                                    boxSizing: "border-box",
                                    marginRight: "-10px !important"
                                }}
                            />

                        </div>

                        <div style={{flex: 1}}>
                            <input type="text"
                                   name="searchValue"
                                   onChange={handleSearchValueChange}
                                   className="form-control"
                                   placeholder="Enter Email, Loyalty ID or Phone Number"
                                   id="searchValue"
                                   style={{
                                       height: "45px",
                                       borderRadius: "8px",
                                       border: "2px solid #dcdcdc",
                                       paddingLeft: "5px",
                                       boxShadow: "none",
                                       width: "330px",
                                       outline: "none"
                                   }}/>

                            <div className="text-danger mt-1">
                                {lookupError.searchValue}
                            </div>
                        </div>

                        <button
                            id="sub_btn"
                            type="submit"
                            disabled={lookingUp}
                            onClick={handleLookup}
                            style={{
                                ...commonControlStyle,
                                width: "140px",
                                backgroundColor: "#007935",
                                color: "#fff",
                                fontWeight: "600",
                                border: "none",
                                flexShrink: 0
                            }}>Look-Up
                            {lookingUp && (
                                <i className="fa fa-spinner fa-spin ms-2"/>
                            )}
                        </button>
                    </div>

                    <div className="text-danger mt-1">
                        {lookupError.fieldType}
                    </div>
                </form>

                {showSummary && <SummaryModal {...showDetails} />}

                {lookUpResponse?.data && (
                    <div className="container mt-4">

                        <ul className="nav nav-tabs" role="tablist">

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "table" ? "active" : ""}`}
                                    type="button"
                                    onClick={() => handleTabClick("table")}
                                >
                                    Details
                                </button>
                            </li>

                            {user?.email && (
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "delete-form" ? "active" : ""}`}
                                        type="button"
                                        onClick={() => handleTabClick("delete-form")}
                                    >
                                        Admin Link
                                    </button>
                                </li>
                            )}

                            {user?.email && lookUpResponse?.meta?.hasDeleteAccess && (
                                <>

                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === "form" ? "active" : ""}`}
                                            type="button"
                                            onClick={() => handleTabClick("form")}
                                        >
                                            Update
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === "employee-status-table" ? "active" : ""}`}
                                            type="button"
                                            onClick={() => handleTabClick("employee-status-table")}
                                        >
                                            Employment
                                        </button>
                                    </li>
                                </>

                            )}



                        </ul>

                        <div className="tab-content mt-3">

                            <div className={`tab-pane fade ${activeTab === "table" ? "show active" : ""}`}>
                                <h4
                                    id="sub_head"
                                    style={{
                                        fontFamily: "A Love of Thunder",
                                        color: "#007935",
                                        marginBottom: "10px"
                                    }}>Customer Details by Sources
                                </h4>

                                <CustomerComparisonTable
                                    lookUpResponse={lookUpResponse}
                                    handleUpdateWynshopLoyaltyId={handleUpdateWynshopLoyaltyId}/>
                                <Auth0DetailsForm auth0Details={auth0Details}/>
                            </div>

                            <div className={`tab-pane fade ${activeTab === "form" ? "show active" : ""}`}>
                                <UpdatePI
                                    registering={registering}
                                    handleSubmit={handleSubmit}
                                    error={error}
                                    cosmosCustomer={cosmosCustomer}
                                    handleChange={handleChange}
                                    defaultStore={defaultStore}
                                    stores={stores}
                                    comparisonSummary={comparisonSummary}
                                    handleBlur={handleBlur}
                                    handleStoreChange={handleStoreChange}/>

                            </div>

                            {employeeStatusList?.length > 0 && (
                                <div
                                    className={`tab-pane fade ${activeTab === "employee-status-table" ? "show active" : ""}`}>
                                    <Employment employeeStatusList={employeeStatusList} warnings={warnings}/>
                                </div>
                            )}

                            {user?.email && (
                                <div className={`tab-pane fade ${activeTab === "delete-form" ? "show active" : ""}`}>
                                    <AdminActions
                                        handleVerifyEmailLink={handleVerifyEmailLink}
                                        handleResetPasswordLink={handleResetPasswordLink}
                                        auth0Details={auth0Details}
                                        user={user}
                                        handleDeleteAccount={handleDeleteAccount}
                                        registering={registering}
                                        hasDeleteAccess={lookUpResponse?.meta?.hasDeleteAccess}
                                    />
                                </div>
                            )}

                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
